import { atom, selector } from 'recoil';

export const widgetState = atom<any[]>({
  key: 'widgets',
  default: [],
});

export const editModeState = atom<boolean>({
  key: 'editMode',
  default: false,
});

export const namespaceState = atom<string>({
  key: 'namespace',
  default: 'default',
});

export const cardState = atom<any[]>({
  key: 'cards',
  default: [],
});

export const layoutState = atom<any>({
  key: 'mylayouts',
  default: {},
});

export const currentCardOrderIdState = atom<any>({
  key: 'cardOrderId',
  default: 0,
});

export const selectedCardState = atom<any>({
  key: 'selectedCard',
  default: undefined,
});

export const gridCardState = atom<any>({
  key: 'gridCards',
  default: [],
});

export const dashboardState = selector({
  key: 'dashboardState',
  get: ({ get }) => {
    const widgets = get(widgetState);
    const editMode = get(editModeState);

    return {
      widgets,
      editMode,
    };
  },
});
